<template>
	<div id="div-main">
		<b-table
			striped hover class="mt-3"
			:items="localVendors"
			:fields="fields"
         small
		><!-- table -->
			<template v-slot:cell(country)="row">
				{{ row.item.country.countryName }}
			</template>
			<template v-slot:cell(deliverygroup)="row">
				{{ deliveryGroups.find(group => group.value == row.item.deliveryGroupId)?.text}}
			</template>
         <template v-slot:cell(deliveryNoteActive)="row">
            <b-form-checkbox v-if="row.item.deliveryNoteActive == 1" size="lg" disabled v-model="yes"/>
            <b-form-checkbox v-else                                  size="lg" disabled v-model="no" />
         </template>
         <template v-slot:cell(autocompleteDeliveryNotes)="row">
            <b-form-checkbox v-if="row.item.autocompleteDeliveryNotes == 1" size="lg" disabled v-model="yes"/>
            <b-form-checkbox v-else                                         size="lg" disabled v-model="no" />
         </template>
         <template v-slot:cell(isActive)="row">
            <b-form-checkbox v-if="row.item.isActive == 1" size="lg" disabled v-model="yes"/>
            <b-form-checkbox v-else                        size="lg" disabled v-model="no" />
         </template>
			<template v-slot:cell(addressId)="row">
				{{ addresses[row.item.addressId] }}
			</template>
			<template v-slot:cell(actions)="row">
				<b-button
						size="sm"
						variant="primary"
						@click="openEditModal(row.item, row.index)"
				>
					<i class="bi bi-pencil-square"></i>
				</b-button>
			</template>
		</b-table>
		<b-modal
				v-model="editModalVisible"
				title="Lieferant bearbeiten"
				ok-title="Speichern"
				cancel-title="Abbrechen"
				size="lg"
				static
				@ok.prevent="saveVendor"
		>
			<b-form-group label="Interne Nummer">
				<b-form-input v-model="editedVendor.id" disabled />
			</b-form-group>

			<b-form-group label="Offizielle LF Nr.">
				<b-form-input v-model="editedVendor.skuPrefix" />
			</b-form-group>

			<b-form-group label="Name">
				<b-form-input v-model="editedVendor.name" />
			</b-form-group>

			<b-form-group label="Land">
				<b-form-select
						v-model="editedVendor.countryId"
						:options="countryOptions"
				/>
			</b-form-group>

			<b-form-group label="LK">
				<b-form-select
						v-model="editedVendor.deliveryClass"
						:options="deliveryClasses"
				/>
			</b-form-group>

			<b-form-group label="Strafertrag">
				<b-form-input
						v-model.number="editedVendor.incomeFine"
						type="number"
				/>
			</b-form-group>

			<b-form-group label="Versandgruppe">
				<b-form-select
						v-model="editedVendor.deliveryGroupId"
						:options="deliveryGroups"
				/>
			</b-form-group>

			<b-form-group label="Hauptlieferant">
				<b-form-select
						v-model="editedVendor.mainVendorId"
						:options="mainVendors"
				/>
			</b-form-group>

			<b-form-group label="Handlingtime">
				<b-form-input
						v-model.number="editedVendor.handlingTime"
						type="number"
				/>
			</b-form-group>

			<b-form-group label="Händleradresse">
				<b-form-select
						v-model="editedVendor.addressId"
						:options="addressOptions"
				/>
			</b-form-group>
			<b-form-checkbox
					:checked="Number(editedVendor.isActive) === 1"
					@change="editedVendor.isActive = $event ? 1 : 0"
			>
				Aktiv
			</b-form-checkbox>

			<b-form-checkbox
					:checked="Number(editedVendor.deliveryNoteActive) === 1"
					@change="editedVendor.deliveryNoteActive = $event ? 1 : 0"
			>
				Lieferschein aktiv
			</b-form-checkbox>

			<b-form-checkbox
					:checked="Number(editedVendor.autocompleteDeliveryNotes) === 1"
					@change="editedVendor.autocompleteDeliveryNotes = $event ? 1 : 0"
			>
				Lieferschein automatisch abschließen
			</b-form-checkbox>
		</b-modal>
	</div>
</template>
<script>
export default {
	props: {
		vendors: {
			type: Array,
			default: () => [],
		},
		deliveryGroups: {
			type: Object,
			default: () => [],
		},
		deliveryClasses: {
			type: Object,
			default: () => [],
		},
		countries: {
			type: Object,
			default: () => [],
		},
		currencies: {
			type: Object,
			default: () => [],
		},
		addresses: {
			type: Object,
			default: () => [],
		},
		mainVendors: {
			type: Object,
			default: () => [],
		},
		shippingServices: {
			type: Array,
			default: () => [],
		},
		user: {
			type: Object,
			default: () => ({}),
		},
	},
   data () {
      return {
         yes: true,
				no: false,
				localVendors: [],
				currencies: [],
				editModalVisible: false,
				editedVendorIndex: null,
				editedVendor: {},
				originalValues: {},
         fields: [
            { key: 'id'                       , label: 'interne Nummer'                        , sortable: true ,                                        },
            { key: 'skuPrefix'                , label: 'offizielle LF Nr'                      , sortable: true ,                                        },
            { key: 'name'                     , label: 'Name'                                 , sortable: true ,                                        },
            { key: 'country'                  , label: 'Land'                                 , sortable: true , 																				 },
            { key: 'deliveryClass'            , label: 'LK'                                   , sortable: true ,                                        },
            { key: 'incomeFine'               , label: 'Strafertrag'                          , sortable: true ,                                        },
            { key: 'deliverygroup'            , label: 'Versandgruppe'                        , sortable: true , 																				},
            { key: 'isActive'                 , label: 'Aktiv'                           			, sortable: true ,                                        },
					 	{ key: 'mainVendorId'             , label: 'Hauptlieferant'                       , sortable: true , formatter: this.mainVendorIdFormatter  },
					 	{ key: 'handlingTime'             , label: 'Handlingtime'                         , sortable: true ,                                        },
					 	{ key: 'deliveryNoteActive'       , label: 'LS aktiv'                   					, sortable: true ,                                        },
					 	{ key: 'autocompleteDeliveryNotes', label: 'LS Abschl'														, sortable: true ,                                        },
					 	{ key: 'addressId'								, label: 'Händleradresse'												, sortable: true ,                                        },
					 	{ key: 'actions'									, label: ''															, sortable: false },
         ]
      }
   },
	computed: {
		countryOptions() {
			return [
				{ value: null, text: 'Bitte wählen...' },
				...Object.values(this.countries).map(country => ({
					value: country.id,
					text: country.countryName,
				})),
			];
		},

		addressOptions() {
			return Object.entries(this.addresses).map(([value, text]) => ({
				value: value === '' ? null : Number(value),
				text,
			}));
		},
	},
   methods: {
      currencyFormatter(currencyId) {
         if(!currencyId) return "-";
         try{
            return this.currencies.find( currency => currencyId == currency.id ).code;
         }catch(e) { return "ERROR" }
      },
      
      mainVendorIdFormatter(mainVendorId) {
         if(!mainVendorId) return "-";
         try{
            return this.vendors.find( vendor => vendor.id == mainVendorId).name;
         }catch(e) { return "ERROR" }
      },
		 openEditModal(vendor, index) {
			 this.editedVendorIndex = index;
			 this.editedVendor = _.cloneDeep(vendor);
			 this.originalValues = _.cloneDeep(vendor);
			 this.editModalVisible = true;
		 },
		 saveVendor() {
			 axios.put(`/vendor/${this.editedVendor.id}`,{
				 ...this.editedVendor,
				 originalValues: this.originalValues,
			 })
				 .then(() => {
					 this.localVendors[this.editedVendorIndex] = _.cloneDeep(this.editedVendor);
					 this.editModalVisible = false;

					 this.$bvToast.toast('Änderungen wurden erfolgreich gespeichert.', {
						 title: 'Erfolgreich',
						 variant: 'success',
						 solid: true,
					 });
				 })
				 .catch((error) => {
					 console.error(error);
					 this.$bvToast.toast('Fehler beim Speichern der Änderungen.', {
						 title: 'Fehler',
						 variant: 'danger',
						 solid: true,
					 });
				 });
		 },
   },
   created() {
      Promise.all([
         axios.get("/vendor/all"),
         axios.get("/currency/all")
      ]).then( ([rVendors, rCurrencies]) => {
				this.localVendors = rVendors.data.sort((v,w) => v.name.localeCompare(w.name));
				this.currencies = rCurrencies.data;
      });
   }
}
</script>
